import * as React from 'react';
import { SlaDefinition } from './SlaDefinition';
import { WidgetProps } from './WidgetProps';

class DatadogWidgetState {
  public uuid = ''
  public comparator: any = ''
  public limit: any = ''
  public aggregator: any = ''
  public metricName: any = ''
  public tags: any = ''
}

export default class DatadogWidget extends React.Component<WidgetProps, DatadogWidgetState> {

  constructor(props: any) {
    super(props);
    this.handleComparatorChange      = this.handleComparatorChange.bind(this);
    this.handleLimitChange           = this.handleLimitChange.bind(this);
    this.handleAggregatorChange      = this.handleAggregatorChange.bind(this);
    this.handleMetricNameChange      = this.handleMetricNameChange.bind(this);
    this.handleTagsChange            = this.handleTagsChange.bind(this);
    this.pushConfigUpdate            = this.pushConfigUpdate.bind(this)

    if (this.props.definition) {
      this.state = {
        uuid: this.props.definition.uuid,
        comparator: this.props.definition.comparator,
        limit: this.props.definition.limit,
        aggregator: this.props.definition.metric.aggregator,
        metricName: this.props.definition.metric.name,
        tags: this.props.definition.metric.tags
      }
    }
  }

  public deleteDefn = (e: any) => {
    e.preventDefault();
    this.props.deleteDefinition();
  };

  public pushConfigUpdate() {
    const def = {
      uuid: this.state.uuid,
      limit: +this.state.limit,
      comparator: this.state.comparator,
      metric: {
        type: 'datadog',
        aggregator: this.state.aggregator,
        name: this.state.metricName,
        tags: [
          this.state.tags
        ]
      }
    } as SlaDefinition;
    this.props.updateDefinition(def)
  }

  public handleComparatorChange(e: any) {
    this.setState({comparator: e.target.value}, this.pushConfigUpdate)
  }
  public handleLimitChange(e: any) {
    this.setState({limit: e.target.value}, this.pushConfigUpdate)
  }
  public handleAggregatorChange(e: any) {
    this.setState({aggregator: e.target.value}, this.pushConfigUpdate)
  }
  public handleMetricNameChange(e: any) {
    this.setState({metricName: e.target.value}, this.pushConfigUpdate)
  }
  public handleTagsChange(e: any) {
    let tagsArray = [] as string[]
    if (e.target.value) {
      tagsArray = e.target.value.split(',').map(function(tag: string) {
        return tag.trim();
      });
    }
    this.setState({tags: tagsArray}, this.pushConfigUpdate)
  }

  public render() {
    return (
      <div className="panel panel-body rounded">
        <div className="form-group row">
          <div className="col-sm-3 sm-label-right">Metric Name</div>
          <div className="col-sm-9">
            <input
              type="text"
              className="form-control input-sm"
              placeholder="eg: system.cpu"
              onChange={this.handleMetricNameChange}
              value={this.state.metricName}
            />
          </div>
        </div>
        <div className="form-group row">
        <div className="col-sm-3 sm-label-right">Comparator</div>
        <div className="col-sm-3">
          <select
            className="form-control input-sm"
            onChange={this.handleComparatorChange}
            defaultValue={this.state.comparator}
          >
            <option value="">Select Comparator</option>
            <option value="<">&lt;</option>
            <option value="<=">&lt;=</option>
            <option value="==">==</option>
            <option value=">=">&gt;=</option>
            <option value=">">&gt;</option>
          </select>
        </div>
        <div className="col-sm-3 sm-label-right">Limit</div>
          <div className="col-sm-3">
            <input
              type="text"
              className="form-control input-sm"
              placeholder="eg: 100"
              onChange={this.handleLimitChange}
              value={this.state.limit}
            />
          </div>
        </div>
        <div className="form-group row">
          <div className="col-sm-3 sm-label-right">Aggregator</div>
          <div className="col-sm-3">
            <select
              className="form-control input-sm"
              onChange={this.handleAggregatorChange}
              defaultValue={this.state.aggregator}
            >
              <option value="">Select Aggregator</option>
              <option value="avg">avg</option>
              <option value="sum">sum</option>
              <option value="min">min</option>
              <option value="max">max</option>
            </select>
          </div>
          <div className="col-sm-3 sm-label-right">Tags</div>
          <div className="col-sm-3">
            <input
              type="text"
              className="form-control input-sm"
              placeholder="eg: foo, bar"
              onChange={this.handleTagsChange}
              value={this.state.tags}
            />
          </div>
        </div>
        <DeleteButton deleteFn={this.deleteDefn} numDefs={this.props.numDefs}/>
      </div>
    );
  }
}

function DeleteButton(props: any) {
  let btn  = null;
  if (props.numDefs > 1) {
    btn = (
      <a onClick={props.deleteFn}>
        <span className="glyphicon glyphicon-trash"/>
        Delete SLA definition
      </a>
    )
  } else {
    btn = (
      <div className="alert alert-info">
        INFO: Cannot delete sole SLA definition
      </div>
    )
  }
  return (
    <div className="form-group row col-sm-12 sm-label-left">
      {btn}
    </div>
  )
}
